export const isEmptyString = (str: string): boolean => {
  return str === '' || str.trim().length === 0;
};

export const isValidEmail = (str: string): boolean => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !isEmptyString(str) && re.test(String(str).toLowerCase());
};
